<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right" *ngIf="!showSearch">
        <div class="ir-btn th-btn-modal" (click)="updateShowSearch()">
          <i class="material-icons">search</i>
        </div>
      </div>
      <div class="ir-line" *ngIf="!showSearch">
        <div class="ir-line-content">
          <span *ngIf="section"
            >{{ 'templates.select-point-from' | translate }} <strong>({{ section.name }})</strong></span
          >
        </div>
      </div>
      <div class="ir-line th-header-search" *ngIf="showSearch">
        <div class="ir-line--left">
          <div class="ir-btn th-btn-unactive">
            <i class="material-icons">search</i>
          </div>
        </div>
        <div class="ir-line--right">
          <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
            <i class="material-icons">close</i>
          </div>
        </div>
        <div class="ir-line-content">
          <input
            autoFocus
            type="search"
            name="Search"
            placeholder="{{ 'common.placeholders.search' | translate }}"
            [(ngModel)]="query"
            focus="showSearch"
          />
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer">
      <div class="ir-content--modal th-content">
        <span *ngIf="loading">loading...</span>
        <div class="ir-item-line th-filter" *ngIf="points?.length">
          <div class="ir-item-cell s5 clickable" (click)="setOrderBy('name')">
            <span>
              <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
              <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
              Name
            </span>
          </div>
          <div (click)="setOrderBy('etag')" class="ir-item-cell s5 clickable">
            <span>
              <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
              <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
              Last modified date
            </span>
          </div>
        </div>
        <div class="ir-item-empty ir-mv8" *ngIf="points?.length == 0">
          <p>
            <span>There is no point here.</span>
          </p>
        </div>
        <div
          class="ir-content-flow"
          *ngIf="points?.length > 0"
          [ngClass]="points?.length > 0 ? 'has-filter has-actions' : ''"
        >
          <div
            *ngFor="let item of points | orderBy: orderByFieldName:direction | searchBy: query"
            class="ir-item-line th-point clickable indent"
            (click)="selectInspectionPoint(item)"
          >
            <!-- if point -->
            <div class="ir-item-cell s5" *ngIf="item.type === 200">
              <div class="ir-item-selector">
                <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
                <i class="material-icons" *ngIf="item.selected">check_box</i>
              </div>
              <span>{{ item.name }}</span>
            </div>
            <div class="ir-item-cell s5" *ngIf="item.type === 200">
              <span>{{ item?.etag | formatDate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.back' | translate }}</span>
          </div>
        </div>

        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            (click)="addPoints()"
            *ngIf="selectedPoints && selectedPoints.length > 0 && !createProcessing"
          >
            <span>{{ 'common.add' | translate }} &laquo; {{ selectedPoints?.length }} &raquo;</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="createProcessing"
          >
            <span>{{ 'templates.processing' | translate }} ...</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            *ngIf="!selectedPoints || selectedPoints.length == 0"
          >
            <span>{{ 'templates.select-point' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
